/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { Brand } from './Brand';
import {
    BrandFromJSON,
    BrandFromJSONTyped,
    BrandToJSON,
} from './Brand';
import type { DeviceInterfaceType } from './DeviceInterfaceType';
import {
    DeviceInterfaceTypeFromJSON,
    DeviceInterfaceTypeFromJSONTyped,
    DeviceInterfaceTypeToJSON,
} from './DeviceInterfaceType';
import type { QaEquipmentSubCategory } from './QaEquipmentSubCategory';
import {
    QaEquipmentSubCategoryFromJSON,
    QaEquipmentSubCategoryFromJSONTyped,
    QaEquipmentSubCategoryToJSON,
} from './QaEquipmentSubCategory';
import type { RtSystemManufacturer } from './RtSystemManufacturer';
import {
    RtSystemManufacturerFromJSON,
    RtSystemManufacturerFromJSONTyped,
    RtSystemManufacturerToJSON,
} from './RtSystemManufacturer';
import type { SingleDetectorConnectorType } from './SingleDetectorConnectorType';
import {
    SingleDetectorConnectorTypeFromJSON,
    SingleDetectorConnectorTypeFromJSONTyped,
    SingleDetectorConnectorTypeToJSON,
} from './SingleDetectorConnectorType';
import type { FileMetaInfoDto } from './FileMetaInfoDto';
import {
    FileMetaInfoDtoFromJSON,
    FileMetaInfoDtoFromJSONTyped,
    FileMetaInfoDtoToJSON,
} from './FileMetaInfoDto';

/**
 * 
 * @export
 * @interface CreateUnicheckSimulatorDto
 */
export interface CreateUnicheckSimulatorDto {
    /**
     * 
     * @type {string}
     * @memberof CreateUnicheckSimulatorDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUnicheckSimulatorDto
     */
    description?: string | null;
    /**
     * 
     * @type {Array<FileMetaInfoDto>}
     * @memberof CreateUnicheckSimulatorDto
     */
    attachments?: Array<FileMetaInfoDto> | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUnicheckSimulatorDto
     */
    isAvailable?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateUnicheckSimulatorDto
     */
    imageId?: string | null;
    /**
     * 
     * @type {QaEquipmentSubCategory}
     * @memberof CreateUnicheckSimulatorDto
     */
    subCategory: QaEquipmentSubCategory;
    /**
     * 
     * @type {RtSystemManufacturer}
     * @memberof CreateUnicheckSimulatorDto
     */
    manufacturer: RtSystemManufacturer;
    /**
     * 
     * @type {string}
     * @memberof CreateUnicheckSimulatorDto
     */
    model: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUnicheckSimulatorDto
     */
    subModel?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUnicheckSimulatorDto
     */
    typeNumber?: string | null;
    /**
     * 
     * @type {Brand}
     * @memberof CreateUnicheckSimulatorDto
     */
    brand1?: Brand;
    /**
     * 
     * @type {DeviceInterfaceType}
     * @memberof CreateUnicheckSimulatorDto
     */
    deviceInterfaceType?: DeviceInterfaceType;
    /**
     * 
     * @type {string}
     * @memberof CreateUnicheckSimulatorDto
     */
    defaultImageId?: string | null;
    /**
     * 
     * @type {SingleDetectorConnectorType}
     * @memberof CreateUnicheckSimulatorDto
     */
    singleDetectorConnectorType?: SingleDetectorConnectorType;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUnicheckSimulatorDto
     */
    isRegistrable?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUnicheckSimulatorDto
     */
    isCalibratable?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUnicheckSimulatorDto
     */
    isZeroMeasurementConfigurable?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateUnicheckSimulatorDto
     */
    serialNumber: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUnicheckSimulatorDto
     */
    $type?: CreateUnicheckSimulatorDtoTypeEnum;
}


/**
 * @export
 */
export const CreateUnicheckSimulatorDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedDeviceComponentDtoCreateUnicheckSimulatorDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.DeviceComponent.Dto.CreateUnicheckSimulatorDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type CreateUnicheckSimulatorDtoTypeEnum = typeof CreateUnicheckSimulatorDtoTypeEnum[keyof typeof CreateUnicheckSimulatorDtoTypeEnum];



/**
 * Check if a given object implements the CreateUnicheckSimulatorDto interface.
 */
export function instanceOfCreateUnicheckSimulatorDto(value?: unknown): value is CreateUnicheckSimulatorDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(CreateUnicheckSimulatorDtoTypeEnum)[0];
}

export function CreateUnicheckSimulatorDtoFromJSON(json: any): CreateUnicheckSimulatorDto {
    return CreateUnicheckSimulatorDtoFromJSONTyped(json, false);
}

export function CreateUnicheckSimulatorDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUnicheckSimulatorDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'attachments': json['attachments'] == null ? undefined : ((json['attachments'] as Array<any>).map(FileMetaInfoDtoFromJSON)),
        'isAvailable': json['isAvailable'] == null ? undefined : json['isAvailable'],
        'imageId': json['imageId'] == null ? undefined : json['imageId'],
        'subCategory': QaEquipmentSubCategoryFromJSON(json['subCategory']),
        'manufacturer': RtSystemManufacturerFromJSON(json['manufacturer']),
        'model': json['model'],
        'subModel': json['subModel'] == null ? undefined : json['subModel'],
        'typeNumber': json['typeNumber'] == null ? undefined : json['typeNumber'],
        'brand1': json['brand1'] == null ? undefined : BrandFromJSON(json['brand1']),
        'deviceInterfaceType': json['deviceInterfaceType'] == null ? undefined : DeviceInterfaceTypeFromJSON(json['deviceInterfaceType']),
        'defaultImageId': json['defaultImageId'] == null ? undefined : json['defaultImageId'],
        'singleDetectorConnectorType': json['singleDetectorConnectorType'] == null ? undefined : SingleDetectorConnectorTypeFromJSON(json['singleDetectorConnectorType']),
        'isRegistrable': json['isRegistrable'] == null ? undefined : json['isRegistrable'],
        'isCalibratable': json['isCalibratable'] == null ? undefined : json['isCalibratable'],
        'isZeroMeasurementConfigurable': json['isZeroMeasurementConfigurable'] == null ? undefined : json['isZeroMeasurementConfigurable'],
        'serialNumber': json['serialNumber'],
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function CreateUnicheckSimulatorDtoToJSON(value?: CreateUnicheckSimulatorDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'name': value['name'],
        'description': value['description'],
        'attachments': value['attachments'] == null ? undefined : ((value['attachments'] as Array<any>).map(FileMetaInfoDtoToJSON)),
        'isAvailable': value['isAvailable'],
        'imageId': value['imageId'],
        'subCategory': QaEquipmentSubCategoryToJSON(value['subCategory']),
        'manufacturer': RtSystemManufacturerToJSON(value['manufacturer']),
        'model': value['model'],
        'subModel': value['subModel'],
        'typeNumber': value['typeNumber'],
        'brand1': BrandToJSON(value['brand1']),
        'deviceInterfaceType': DeviceInterfaceTypeToJSON(value['deviceInterfaceType']),
        'defaultImageId': value['defaultImageId'],
        'singleDetectorConnectorType': SingleDetectorConnectorTypeToJSON(value['singleDetectorConnectorType']),
        'isRegistrable': value['isRegistrable'],
        'isCalibratable': value['isCalibratable'],
        'isZeroMeasurementConfigurable': value['isZeroMeasurementConfigurable'],
        'serialNumber': value['serialNumber'],
        '$type': value['$type'],
    });
}

